module.exports = __webpack_public_path__ + "catalog/items/canteen-table/canteen_table.png";